import { Link as KitLink } from '@mui/material';
import React from 'react';

function Link(props: any) {
  const { disabled, ...rest } = props;

  return (
    <KitLink
      disabled={disabled}
      sx={{
        color: disabled ? 'lightgray' : 'primary',
        pointerEvents: disabled ? 'none' : 'auto',
        cursor: disabled ? 'not-allowed' : 'pointer',
        textDecoration: 'none',
        fontFamily: 'Inter, Proxima Nova, sans-serif',
        '&:hover': {
          textDecoration: 'underline',
        },
      }}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
    />
  );
}

export default Link;
